import makeStyles from '@mui/styles/makeStyles'

const padding = '10px 20px'

const useStyles = makeStyles(theme => ({
  wrapper: {
    margin: '0',
    padding: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  item: {
    padding,
    fontSize: theme.size.sm
  },

  disabled: {
    padding,
    fontSize: theme.size.sm,
    pointerEvents: 'none',
    opacity: '0.25'
  }
}))

export default useStyles
